import { VIEWPORT_PADDING } from "../../../../ui-kit/lib/floating";

export const NAV_Z_INDEX = "z-[var(--z-index-nav-layout)]";
export const NAV_Z_INDEX_VALUE = "var(--z-index-nav-layout)";

const COLLAPSED_TOOLBAR_HEIGHT = 40;
export const COLLAPSED_PANEL_OFFSET = COLLAPSED_TOOLBAR_HEIGHT + VIEWPORT_PADDING;
